import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ApplicationsSummaryTablesComponent } from './applications-summary-tables/applications-summary-tables.component';
import { G, L } from '@angular/cdk/keycodes';
import { GmonOverviewComponent } from './applications-summary-tables/gmon-overview/gmon-overview.component';
import { LaOverviewComponent } from './applications-summary-tables/la-overview/la-overview.component';
import { PlanningOverviewComponent } from './applications-summary-tables/planning-overview/planning-overview.component';
import { GmonPlanningComponent } from './applications-summary-tables/gmon-planning/gmon-planning.component';
import { LaPlanningComponent } from './applications-summary-tables/la-planning/la-planning.component';
import { AlarmsMenuComponent } from './applications-summary-tables/alarms-menu/alarms-menu.component';

const routes: Routes = [
  {
    path: '', component: LoginComponent, canActivate: []
  },
  {
    path: 'home', component: HomeComponent, canActivate: []
  },
  {
    path: 'applications-results', component: ApplicationsSummaryTablesComponent, canActivate: []
  },
  {
    path: 'gmon-overview', component: GmonOverviewComponent, canActivate: []
  },
  {
    path: 'la-overview', component: LaOverviewComponent, canActivate: []
  },
  {
    path: 'planning-overview', component: PlanningOverviewComponent, canActivate: []
  },
  {
    path: 'gmon-planning-overview', component: GmonPlanningComponent, canActivate: []
  },
  {
    path: 'la-planning-overview', component: LaPlanningComponent, canActivate: []
  },
  {
    path: 'alarms-menu', component: AlarmsMenuComponent, canActivate: []
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
